var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82642 5.48019L13.0554 0.289185C13.2415 0.104277 13.4931 0.000488281 13.7554 0.000488281C14.0177 0.000488281 14.2694 0.104277 14.4554 0.289185C14.5471 0.379935 14.6198 0.48796 14.6694 0.606995C14.7191 0.726029 14.7446 0.853724 14.7446 0.982697C14.7446 1.11167 14.7191 1.23936 14.6694 1.3584C14.6198 1.47743 14.5471 1.58543 14.4554 1.67618L8.52734 7.56119C8.3413 7.7461 8.0897 7.84988 7.82739 7.84988C7.56509 7.84988 7.31349 7.7461 7.12744 7.56119L1.19934 1.67618C1.1077 1.58543 1.035 1.47743 0.985352 1.3584C0.935705 1.23936 0.910156 1.11167 0.910156 0.982697C0.910156 0.853724 0.935705 0.726029 0.985352 0.606995C1.035 0.48796 1.1077 0.379935 1.19934 0.289185C1.38539 0.104277 1.63711 0.000488281 1.89941 0.000488281C2.16172 0.000488281 2.41332 0.104277 2.59937 0.289185L7.82642 5.48019Z",
    fill: "#8A939F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.b6b365d030fb9da6d7ace24ff232004f.svg";
export { ForwardRef as ReactComponent };